module.exports = __webpack_public_path__ + "static/scale-model-of-barbie-pond-on-avenue-q-in-washington-d.c.-64a6731dbb398ede093c2fb26f52bec8.png";